

const PlusIcon = (props: any) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.4375 6.73999C11.4375 6.84359 11.3963 6.94295 11.3231 7.0162C11.2498 7.08946 11.1505 7.13062 11.0469 7.13062H7.14062V11.0369C7.14062 11.1405 7.09947 11.2398 7.02621 11.3131C6.95296 11.3863 6.8536 11.4275 6.75 11.4275C6.6464 11.4275 6.54704 11.3863 6.47379 11.3131C6.40053 11.2398 6.35938 11.1405 6.35938 11.0369V7.13062H2.45312C2.34952 7.13062 2.25017 7.08946 2.17691 7.0162C2.10366 6.94295 2.0625 6.84359 2.0625 6.73999C2.0625 6.63639 2.10366 6.53703 2.17691 6.46378C2.25017 6.39052 2.34952 6.34937 2.45312 6.34937H6.35938V2.44312C6.35938 2.33952 6.40053 2.24016 6.47379 2.1669C6.54704 2.09365 6.6464 2.05249 6.75 2.05249C6.8536 2.05249 6.95296 2.09365 7.02621 2.1669C7.09947 2.24016 7.14062 2.33952 7.14062 2.44312V6.34937H11.0469C11.1505 6.34937 11.2498 6.39052 11.3231 6.46378C11.3963 6.53703 11.4375 6.63639 11.4375 6.73999Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PlusIcon;
